// import React from "react";
// import { ReactP5Wrapper } from "react-p5-wrapper"; // im using "react-p5-wrapper": "^3.0.2",

// function grid(p){
//   const GRID_COLOR = [200, 200, 200, 80]; // Light gray with low alpha
//   p.push();
//   p.stroke(...GRID_COLOR);
//   p.strokeWeight(1);
//   let step = 40; // Size of grid squares

//   // Draw grid much larger than canvas so it doesn't "run out" during camera movement
//   let gridSize = 2000;
//   for (let x = -gridSize; x <= gridSize; x += step) {
//       p.line(x, -gridSize, x, gridSize);
//   }
//   for (let y = -gridSize; y <= gridSize; y += step) {
//       p.line(-gridSize, y, gridSize, y);
//   }
//   p.pop();
// }

// function Fully({ p5ref, wt, ht, scale, fs, bgcolor }) {
//   const sketch = (p) => {
//     // --- Color definitions ---
//     let BLACK = [51, 51, 51];
//     let PINK = [235, 93, 123];
//     let BLUE = [93, 105, 235];
//     let BEIGE = [255, 254, 246];

//     let firstText = "A full world beats a fraction of a galaxy.";
//     let secondText = "";
//     let latoFont = "Lato";
//     let feelWidths = [];
//     let doWidths = [];
//     let spaceKerning = 4.75;

//     let leftTileSize, rightTileSize;
//     let leftX, rightX, centerY;
//     let smallLeftTileSize;

//     let gridSize = 9;
//     let spacing = 5;
//     let tileSize;

//     let zoomLevel = 22;
//     let zoomTarget = 2;
//     let zoomSpeed = 0.02;

//     let startTime;
//     let fadeStartDelay = 0.5;
//     let fadeDuration = 0.5;
//     let fadeAlpha = 0;
//     let zoomOutStarted = false;

//     const letter_extra_space = {
//       a: 1.7, b: 1, c: 1, d: 1, e: 1.5, f: 0, g: 1, h: 1, i: 1, j: 1,
//       k: 1, l: 0.1, m: 1, n: 1, o: 1, p: 1, q: 1, r: -0.2, s: 2, t: 0,
//       u: 1, v: 0, w: 1, x: 1, y: 1, z: 1,
//       A: 1, B: 1, C: 1, D: 1, E: 1, F: 1, G: 1, H: 1, I: 1, J: 1,
//       K: 1, L: 0.5, M: 1, N: 1, O: 1, P: 1, Q: 1, R: 1, S: 1, T: 1,
//       U: 1, V: 1, W: 1, X: 1, Y: 1, Z: 1,
//     };

//     function preloadFont(url) {
//       return new Promise((resolve) => {
//         const link = document.createElement("link");
//         link.href = url;
//         link.rel = "stylesheet";
//         link.onload = resolve;
//         document.head.appendChild(link);
//       });
//     }

//     p.setup = async () => {
//       await preloadFont("https://fonts.googleapis.com/css2?family=Lato&display=swap");

//       p.createCanvas(wt, ht);
//       p.rectMode(p.CENTER);
//       p.ellipseMode(p.CENTER);
//       p.textSize(fs);

//       try {
//         p.textFont("Lato");
//       }
//       catch (e) {
//         p.textFont("sans-serif");
//       }

//       // Precalculate character widths
//       for (let i = 0; i < firstText.length; i++) {
//         let w = p.textWidth(firstText[i]);
//         feelWidths[i] =
//           w + (firstText[i] === " " ? spaceKerning : letter_extra_space[firstText[i]] || 0);
//       }

//       for (let i = 0; i < secondText.length; i++) {
//         let w = p.textWidth(secondText[i]);
//         doWidths[i] =
//           w + (secondText[i] === " " ? spaceKerning : letter_extra_space[secondText[i]] || 0);
//       }

//       leftTileSize = p.width * 0.4 * 0.6;
//       rightTileSize = leftTileSize * 0.925;

//       leftX = p.width * 0.3;
//       rightX = p.width * 0.7;
//       centerY = p.height / 2;

//       smallLeftTileSize = leftTileSize * 0.925;

//       tileSize = (rightTileSize - (gridSize + 13) * spacing) / gridSize;


//       startTime = p.millis();
//     };

//     function maincontent() {
//       p.push();

//       // --- Fade-in ---
//       let elapsed = p.millis() - startTime;
//       if (elapsed > fadeStartDelay) {
//         let t = p.constrain((elapsed - fadeStartDelay) / fadeDuration, 0, 1);
//         fadeAlpha = p.lerp(0, 180, t);
//         if (t >= 1) zoomOutStarted = true;
//       }

//       // --- Zoom-out animation ---
//       if (zoomOutStarted && zoomLevel > zoomTarget) {
//         zoomLevel = p.lerp(zoomLevel, zoomTarget, zoomSpeed);
//       }

//       // --- Small left square ---
//       p.stroke('');
//       p.fill(PINK);
//       p.rect(leftX, centerY, smallLeftTileSize, smallLeftTileSize);

//       // --- Add ">" between left square and right grid ---
//       if (zoomLevel < 3) {
//         p.push();
//         p.textFont("Lato");
//         p.stroke('');
//         p.fill(BLACK);
//         p.textSize(fs * 2);
//         let middleX = (leftX + rightX - 15) / 2;   // horizontal middle between the two objects
//         let middleY = centerY;                // vertically aligned with center
//         p.text(">", middleX, middleY + fs / 2); // adjust +fs/2 to center the text vertically
//         p.pop();
//       }

//       // --- Right grid with clipping ---
//       p.push();
//       p.translate(rightX - rightTileSize / 2, centerY - rightTileSize / 2);

//       const ctx = p.drawingContext;
//       ctx.save();
//       ctx.beginPath();
//       ctx.rect(0, 0, rightTileSize, rightTileSize);
//       ctx.clip();

//       p.translate(rightTileSize / 2, rightTileSize / 2);
//       p.scale(zoomLevel);
//       p.strokeWeight(1 / zoomLevel);
//       p.noFill();

//       const mid = Math.floor(gridSize / 2);
//       const midTileX = mid * (tileSize + spacing) + tileSize / 2;
//       const midTileY = mid * (tileSize + spacing) + tileSize / 2;

//       p.translate(-midTileX, -midTileY);

//       for (let row = 0; row < gridSize; row++) {
//         for (let col = 0; col < gridSize; col++) {
//           const color_ = row === mid && col === mid ? PINK : BLUE
//           p.stroke(color_);
//           p.fill(color_);
//           p.rect(col * (tileSize + spacing) + tileSize / 2, row * (tileSize + spacing) + tileSize / 2, tileSize, tileSize);
//         }
//       }

//       ctx.restore();
//       p.pop();
//     }

//     const statictext = () => {
//       p.push();
//       p.textSize(fs);
//       p.textFont(latoFont);
//       p.textAlign(p.LEFT, p.CENTER);
//       p.fill(BLACK);

//       let cx = p.width / 2;
//       let firstY = p.height - 120;
//       let secondY = firstY + 24;

//       let firstWidth = feelWidths.reduce((a, b) => a + b, 0);
//       let secondWidth = doWidths.reduce((a, b) => a + b, 0);

//       let x = cx - firstWidth / 2;
//       for (let i = 0; i < firstText.length; i++) {
//         p.text(firstText[i], x, firstY);
//         x += feelWidths[i];
//       }

//       x = cx - secondWidth / 2;
//       for (let i = 0; i < secondText.length; i++) {
//         p.text(secondText[i], x, secondY);
//         x += doWidths[i];
//       }

//       p.pop();
//     };


//     p.draw = () => {
//       p.background(...BEIGE);
//       grid(p);
//       statictext();
//       maincontent();
//     };
//   };

//   return <div style={{ backgroundColor: bgcolor }}>
//     <div ref={p5ref} style={{ transform: `scale(${scale})` }}>
//       <ReactP5Wrapper sketch={sketch} />
//     </div>
//   </div>

// }

// export default Fully


import React from "react";
import { ReactP5Wrapper } from "react-p5-wrapper"; // im using "react-p5-wrapper": "^3.0.2",

function grid(p) {
  const GRID_COLOR = [200, 200, 200, 80]; // Light gray with low alpha
  p.push();
  p.stroke(...GRID_COLOR);
  p.strokeWeight(1);
  let step = 40; // Size of grid squares

  // Draw grid much larger than canvas so it doesn't "run out" during camera movement
  let gridSize = 2000;
  for (let x = -gridSize; x <= gridSize; x += step) {
    p.line(x, -gridSize, x, gridSize);
  }
  for (let y = -gridSize; y <= gridSize; y += step) {
    p.line(-gridSize, y, gridSize, y);
  }
  p.pop();
}

function Fully({ p5ref, wt, ht, scale, fs, bgcolor }) {
  const sketch = (p) => {
    // --- Color definitions ---
    let BLACK = [51, 51, 51];
    let PINK = [235, 93, 123];
    let BLUE = [93, 105, 235];
    let BEIGE = [255, 254, 246];

    let firstText = "A full world beats a fraction of a galaxy.";
    let secondText = "";
    let latoFont = "Lato";
    let feelWidths = [];
    let doWidths = [];
    let spaceKerning = 4.75;

    let leftTileSize, rightTileSize;
    let leftX, rightX, centerY;
    let smallLeftTileSize;

    let gridSize = 9;
    let spacing = 5;
    let tileSize;

    let zoomLevel = 22;
    let zoomTarget = 2;
    let zoomSpeed = 0.02;

    let startTime;
    let fadeStartDelay = 0.5;
    let fadeDuration = 0.5;
    let fadeAlpha = 0;
    let zoomOutStarted = false;

    const letter_extra_space = {
      a: 1.7, b: 1, c: 1, d: 1, e: 1.5, f: 0, g: 1, h: 1, i: 1, j: 1,
      k: 1, l: 0.1, m: 1, n: 1, o: 1, p: 1, q: 1, r: -0.2, s: 2, t: 0,
      u: 1, v: 0, w: 1, x: 1, y: 1, z: 1,
      A: 1, B: 1, C: 1, D: 1, E: 1, F: 1, G: 1, H: 1, I: 1, J: 1,
      K: 1, L: 0.5, M: 1, N: 1, O: 1, P: 1, Q: 1, R: 1, S: 1, T: 1,
      U: 1, V: 1, W: 1, X: 1, Y: 1, Z: 1,
    };

    function preloadFont(url) {
      return new Promise((resolve) => {
        const link = document.createElement("link");
        link.href = url;
        link.rel = "stylesheet";
        link.onload = resolve;
        document.head.appendChild(link);
      });
    }

    p.setup = async () => {
      await preloadFont("https://fonts.googleapis.com/css2?family=Lato&display=swap");

      p.createCanvas(wt, ht);
      p.rectMode(p.CENTER);
      p.ellipseMode(p.CENTER);
      p.textSize(fs);

      try {
        p.textFont("Lato");
      }
      catch (e) {
        p.textFont("sans-serif");
      }

      // Precalculate character widths
      for (let i = 0; i < firstText.length; i++) {
        let w = p.textWidth(firstText[i]);
        feelWidths[i] =
          w + (firstText[i] === " " ? spaceKerning : letter_extra_space[firstText[i]] || 0);
      }

      for (let i = 0; i < secondText.length; i++) {
        let w = p.textWidth(secondText[i]);
        doWidths[i] =
          w + (secondText[i] === " " ? spaceKerning : letter_extra_space[secondText[i]] || 0);
      }

      leftTileSize = p.width * 0.4 * 0.6;
      rightTileSize = leftTileSize * 0.925;

      leftX = p.width * 0.3;
      rightX = p.width * 0.7;
      centerY = p.height / 2;

      smallLeftTileSize = leftTileSize * 0.925;

      tileSize = (rightTileSize - (gridSize + 13) * spacing) / gridSize;


      startTime = p.millis();
    };


    function maincontent() {
      p.push();

      // --- Fade-in ---
      let elapsed = p.millis() - startTime;
      if (elapsed > fadeStartDelay) {
        let t = p.constrain((elapsed - fadeStartDelay) / fadeDuration, 0, 1);
        fadeAlpha = p.lerp(0, 180, t);
        if (t >= 1) zoomOutStarted = true;
      }

      // --- Zoom-out animation ---
      if (zoomOutStarted && zoomLevel > zoomTarget) {
        zoomLevel = p.lerp(zoomLevel, zoomTarget, zoomSpeed);
      }

      // --- Left Square Animation Logic ---
      // We map the zoomLevel (22 -> 2) to a scale factor (e.g., 0.1 -> 1.0)
      // This ensures the expansion duration is identical to the right side's zoom.
      let leftScale = p.map(zoomLevel, 22, 2, 0.1, 1.0);
      let currentLeftSize = smallLeftTileSize * leftScale;

      p.stroke('');
      p.fill(PINK);
      // Draw the expanding square
      p.rect(leftX, centerY, currentLeftSize, currentLeftSize);

      // --- Add ">" between left square and right grid ---
      // Note: Only shows up when the expansion/zoom is nearly finished
      if (zoomLevel < 3) {
        p.push();
        p.textFont("Lato");
        p.stroke('');
        p.fill(BLACK);
        p.textSize(fs * 2);
        let middleX = (leftX + rightX - 15) / 2;
        let middleY = centerY;
        p.text(">", middleX, middleY + fs / 2);
        p.pop();
      }

      // --- Right grid with clipping (Remains the same) ---
      p.push();
      p.translate(rightX - rightTileSize / 2, centerY - rightTileSize / 2);

      const ctx = p.drawingContext;
      ctx.save();
      ctx.beginPath();
      ctx.rect(0, 0, rightTileSize, rightTileSize);
      ctx.clip();

      p.translate(rightTileSize / 2, rightTileSize / 2);
      p.scale(zoomLevel);
      p.strokeWeight(1 / zoomLevel);
      p.noFill();

      const mid = Math.floor(gridSize / 2);
      const midTileX = mid * (tileSize + spacing) + tileSize / 2;
      const midTileY = mid * (tileSize + spacing) + tileSize / 2;

      p.translate(-midTileX, -midTileY);

      for (let row = 0; row < gridSize; row++) {
        for (let col = 0; col < gridSize; col++) {
          const color_ = row === mid && col === mid ? PINK : BLUE;
          p.stroke(color_);
          p.fill(color_);
          p.rect(
            col * (tileSize + spacing) + tileSize / 2,
            row * (tileSize + spacing) + tileSize / 2,
            tileSize,
            tileSize
          );
        }
      }

      ctx.restore();
      p.pop();
      p.pop();
    }


    const statictext = () => {
      p.push();
      p.textSize(fs);
      p.textFont(latoFont);
      p.textAlign(p.LEFT, p.CENTER);
      p.fill(BLACK);

      let cx = p.width / 2;
      let firstY = p.height - 120;
      let secondY = firstY + 24;

      let firstWidth = feelWidths.reduce((a, b) => a + b, 0);
      let secondWidth = doWidths.reduce((a, b) => a + b, 0);

      let x = cx - firstWidth / 2;
      for (let i = 0; i < firstText.length; i++) {
        p.text(firstText[i], x, firstY);
        x += feelWidths[i];
      }

      x = cx - secondWidth / 2;
      for (let i = 0; i < secondText.length; i++) {
        p.text(secondText[i], x, secondY);
        x += doWidths[i];
      }

      p.pop();
    };


    p.draw = () => {
      p.background(...BEIGE);
      grid(p);
      statictext();
      maincontent();
    };
  };

  return <div style={{ backgroundColor: bgcolor }}>
    <div ref={p5ref} style={{ transform: `scale(${scale})` }}>
      <ReactP5Wrapper sketch={sketch} />
    </div>
  </div>

}

export default Fully